export default __webpack_public_path__ + "static/media/hk_flashpay_fees_backgound.d721fc86.png";